import { render, staticRenderFns } from "./PeersPlayerCounts.vue?vue&type=template&id=3fb7b475&scoped=true"
import script from "./PeersPlayerCounts.vue?vue&type=script&lang=js"
export * from "./PeersPlayerCounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb7b475",
  null
  
)

export default component.exports